<template>
  <div class="container">
    <div class="home"><router-link to="/">Zurück</router-link></div>
  </div>
</template>

<script>
export default {
  name: "Privacy",
  mounted() {
    window.open("https://www.bsb-muenchen.de/datenschutzerklaerung/");
    // window.location = "https://www.bsb-muenchen.de/datenschutzerklaerung/";
    // window.location = "http://192.168.56.101:8080";
  },
};
</script>
<style scoped>
a {
  color: #ff6600;
}
.home {
  font-size: 20px;
  text-align: start;
  margin: 10px;
}
@media (max-width: 600px) {
  .home {
    margin-left: 25px;
    margin-top: 25px;
  }
}

@media (max-width: 363px) {
  .home {
    margin-left: 15px;
  }
}
</style>
